/**
 * Datas do prazo de acesso como a API as troca: 'YYYY-MM-DD', o último dia de
 * acesso no calendário de Brasília (inclusivo). Quem decide se venceu é o
 * backend; aqui é só formatação.
 */
import { utcIsoToBrtFields } from './brtDateTime';

/** Hoje em Brasília, no formato do `input[type=date]`. */
export function todayInBrt(): string {
  return utcIsoToBrtFields(new Date()).date;
}

/** '2027-03-12' → '12/03/2027'. Vazio para null/inválido. */
export function formatEndDate(date?: string | null): string {
  if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return '';
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
}

/** A data é anterior a hoje (Brasília)? Encerrar acesso pede confirmação extra. */
export function isBeforeTodayBrt(date?: string | null): boolean {
  return !!date && date < todayInBrt();
}
